import { render, staticRenderFns } from "./EventHistory.vue?vue&type=template&id=11612b20&scoped=true&"
import script from "./EventHistory.vue?vue&type=script&lang=js&"
export * from "./EventHistory.vue?vue&type=script&lang=js&"
import style0 from "./EventHistory.vue?vue&type=style&index=0&id=11612b20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11612b20",
  null
  
)

export default component.exports